import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { text } from "../data/text";
import { customer_service, more_links, social } from "../data/links";
import logo from "../assets/logo.png";
import logo2 from "../assets/SS_710205798.png";
import star from "../assets/star.png";
import trustpilot from "../assets/trustpilot.png";
import master from "../assets/master.png";
import visa from "../assets/visa.png";
import paypal from "../assets/paypal.png";
import express from "../assets/express.png";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import { BsClock } from "react-icons/bs";
import { BsCalendar3 } from "react-icons/bs";

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const footerRef = useRef(null);

  const shortText = text.slice(0, 200);

  useEffect(() => {
    if (!footerRef.current) return;
    gsap.from(footerRef.current.querySelectorAll(".footer-animate"), {
      y: 40,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: footerRef.current,
        start: "top 90%",
        toggleActions: "play none none none",
      },
    });
  }, []);

  return (
    <footer ref={footerRef} className="bg-black text-white font-outfit">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-12">
        {/* TOP SECTION */}
        <div className="footer-animate grid grid-cols-1 lg:grid-cols-4 gap-10">
          {/* LEFT SECTION */}
          <div className="flex flex-col gap-5">
            {/* Logos */}
            <div className="flex items-center gap-4 flex-wrap">
              <img src={logo} className="w-[110px] object-contain" />
              <div className="w-px h-10 bg-gray-700 hidden sm:block" />
              <img src={logo2} className="w-[110px] object-contain" />
            </div>

            {/* Description */}
            <p className="text-sm text-gray-400 leading-relaxed">
              {isExpanded ? text : `${shortText}... `}
              <span
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-white underline cursor-pointer text-xs ml-1"
              >
                {isExpanded ? "Show Less" : "Read More"}
              </span>
            </p>

            {/* Social */}
            <div>
              <p className="font-semibold mb-2">Follow Us</p>
              <div className="flex gap-4 flex-wrap">
                {social.map((link, i) => (
                  <Link
                    key={i}
                    to={link.link}
                    className="text-white text-xl hover:text-yellow-300 transition"
                  >
                    <link.icon />
                  </Link>
                ))}
              </div>
            </div>

            {/* Trustpilot */}
            <div className="flex items-center gap-3 flex-wrap">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <img key={i} src={star} className="w-[16px] h-[16px]" />
                ))}
              </div>
              <img src={trustpilot} className="h-[20px]" />
            </div>
          </div>

          {/* LINKS GRID */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:col-span-3">
            {/* Customer Services */}
            <div>
              <h3 className="font-semibold mb-4">Customer Services</h3>
              <div className="flex flex-col gap-2 text-gray-400 text-sm">
                {customer_service.map((link, i) => (
                  <Link
                    key={i}
                    to={link.link}
                    className="hover:text-yellow-300 transition"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>

            {/* More Links */}
            <div>
              <h3 className="font-semibold mb-4">More Links</h3>
              <div className="flex flex-col gap-2 text-gray-400 text-sm">
                {more_links.map((link, i) => (
                  <Link
                    key={i}
                    to={link.link}
                    className="hover:text-yellow-300 transition"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-semibold mb-4">We Can Help You?</h3>

              <div className="flex flex-col gap-3 text-sm text-gray-400">
                <div className="flex items-center gap-2">
                  <FaPhone />
                  <span>+1 123-456-7489</span>
                </div>

                <div className="flex items-center gap-2">
                  <MdEmail />
                  <span className="break-all">
                    info@giftofgodfragrances.com
                  </span>
                </div>

                <div className="flex items-start gap-2">
                  <CiLocationOn className="mt-1" />
                  <span>
                    Wilson 351 Inc
                    <br />
                    7354 Park Ave #8B
                    <br />
                    Springfield, WY
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  <BsClock />
                  <span>10AM - 6PM EST</span>
                </div>

                <div className="flex items-center gap-2">
                  <BsCalendar3 />
                  <span>Monday - Friday</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="border-t border-gray-800 my-8" />

        {/* BOTTOM */}
        <div className="footer-animate flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm">
          <p>© 2026 Gift Of God Fragrance. All Rights Reserved</p>

          <p>
            Powered By{" "}
            <span className="text-white font-semibold">
              Design Verse Studios
            </span>
          </p>

          <div className="flex gap-3 flex-wrap justify-center">
            <img src={visa} className="h-[24px]" />
            <img src={express} className="h-[24px]" />
            <img src={master} className="h-[24px]" />
            <img src={paypal} className="h-[24px]" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
